import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useFetchWithBody, usePost } from '../../api/reactQueryCustomHooks';
import {
    Box, Button, Grid, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, TextField, Typography, FormControl, InputLabel,
    Select, MenuItem, IconButton, InputAdornment, Popover, useMediaQuery, Chip, Alert, AlertTitle, ListSubheader,
    CircularProgress,
    ToggleButton,
    ToggleButtonGroup
} from '@mui/material';

import { format } from 'date-fns';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { apiRoute, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_STATUS, getModMandatory } from '../../constants/enum';
import { useSelector } from 'react-redux';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { Tab, Tabs } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { autoTable } from "jspdf-autotable"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faDownload, faDownLong, faFilter, faInfo, faRefresh, faSearch } from '@fortawesome/free-solid-svg-icons';
import { ErrorCard, LoadingCard, MainContainer, MUIDataTable } from '../../components';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { head } from 'lodash';
import { toast } from 'react-toastify';

export const ALL_COLUMNS = {

    BrokerDesc: { label: "Broker", group: "broker", type: "string" },
    PartyName: { label: "Party", group: "none", type: "string" },
    Chal_Date: { label: "Date", group: "date", type: "date" },
    YearMonth: { label: "Month", group: "month", type: "string" },
    Chal_No: { label: "Memo No", group: "none", type: "string" },
    Memo_Status: { label: "Status", group: "none", type: "string" },
    L_Code: { label: "Lot No", group: "none", type: "string" },
    PktNo: { label: "Pkt No", group: "none", type: "string" },
    Weight: { label: "Weight", type: "number" },
    Pcs: { label: "Pcs", type: "number" },
    Rate: { label: "Rate (₹)", rupees: true, type: "number", weighted: true },
    S_Rate: { label: "Rate ($)", dollar: true, type: "number", weighted: true },
    Amount: { label: "Amount (₹)", rupees: true, type: "number" },
    AmountD: { label: "Amount ($)", dollar: true, type: "number" },
    //  NetAmtRs: { label: "Net Amt (₹)", rupees: true, type: "number" },
    //NetAmtD: { label: "Net Amt ($)", dollar: true, type: "number" },

    S_Name: { label: "Shape", group: "none", type: "string" },
    Sh_Name: { label: 'Color', group: "none", type: "string" },
    Q_Name: { label: 'Clarity', group: "none", type: "string" },
    ReportNo: { label: "Report", group: "none", type: "string" },
    Cut: { label: 'Cut', group: "none", type: "string" },
    Polish: { label: 'Polish', group: "none", type: "string" },
    Symtry: { label: 'Sym', group: "none", type: "string" },
    Flrn: { label: "Flrn", group: "none", type: "string" },
    
    Stn_Lnth: { label: "Length", group: "none", type: "string" },
    Dia: { label: 'Dia', group: "none", type: "number" },
    LabId: { label: "Lab", group: "none", type: "string" },
    // SL_Code: { label: "Mfg Lot No", group: "none", type: "string" },

   // SPktNo: { label: "Mfg Pkt No", group: "none", type: "string" },
   
};

export const getColumns = (groupBy, activeTab, useMktAsMfg = true) => {
    return Object.entries(ALL_COLUMNS)
        .filter(([key, col]) => {
            // Handle SL_Code
            if (key === "SL_Code") {
                if (!useMktAsMfg) {
                    return groupBy === "none" || groupBy === "slcode";
                } else {
                    return false;
                }
            }
            if (key === "L_Code") {
                if (useMktAsMfg) {
                    return groupBy === "none" || groupBy === "slcode";
                }
            }
            if (key === "PartyName") {
                return groupBy === "none" || groupBy === "party";
            }

            if (key === "SPktNo") {
                return !useMktAsMfg && groupBy === "none";
            }

            // Handle grouped columns
            if (col.group && col.group !== groupBy) return false;

            // Handle currency tabs
            //if (col.rupees && activeTab === "dollar") return false;
            // if (col.dollar && activeTab === "rupees") return false;

            return true;
        })
        .map(([key, col]) => ({ key, ...col }));
};
;


const MemoReport = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [tabValue, setTabValue] = useState(0);
    const [activeTab, setActiveTab] = useState('all');

    const { compCode, compName, startDate, endDate } = useSelector((state) => state.company);
    const tableRef = useRef(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [currentFilterColumn, setCurrentFilterColumn] = useState('');
    const [groupBy, setGroupBy] = useState('none');
    const [isUseMfgNoAsMktno, setIsUseMfgNoAsMktno] = useState(true)
    const [columnFilters, setColumnFilters] = useState({
        Chal_No: '',
        Chal_Date: '',
        YearMonth: '',
        PartyName: '',
        L_Code: '',
        PktNo: '',
        SL_Code: '',
        SPktNo: '',
        Weight: '',
        Pcs: '',
        Rate: '',
        Amount: '',
        // NetAmtRs: '',
        BrokerDesc: '',
        S_Name: '',
        Memo_Status: '',
        Sh_Name: '',
        Q_Name: '',
        Stn_Lnth: '',
        Dia: 0,
        LabId: '',
        ReportNo: '',
        Cut: '',
        polish: '',
        Symtry: '',
        Flrn: '',
    });

    const [filters, setFilters] = useState({
        compCode: compCode,
        dy: '1',
        acYear: '1',
        billType: 'S',
        acType: '13',
        Ac_id: '',
        tradeOf: '',
        Trade_Type: 'ALL',
        Memo_Status: 'ALL',
        Pkt_Type: 'ALL',
        fromDate: dayjs(Date()).format("YYYY-MM-DD"),// startDate.split('T')[0],
        toDate: dayjs(Date()).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
    });

    const exportColumnKeys = [
        "Chal_No",
        "Chal_Date",
        "PartyName",
        "L_Code",
        "PktNo",
        // "SL_Code",
        // "SPktNo",
        "Weight",
        "Pcs",
        "Rate",
        "S_Rate",
        "Amount",
        "AmountD",
        // "NetAmtRs",
        //"NetAmtD",
    ];

    const { isError: isErrorModSet, data: modSetting = [] } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingInwardItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })
    useEffect(() => {
        if (modSetting && modSetting.length > 0) {
            const mktSetting = getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.UseMfgNoAsMktNo, modSetting);
            setIsUseMfgNoAsMktno(mktSetting)
        }
    }, [modSetting])
    const { data: partyData = [] } = useFetchWithBody({
        url: apiRoute.salesData.getParties,
        queryKey: ['salesParties', filters.acType, filters.tradeOf],
        inputData: {
            compCode: compCode[0],
            acType: filters.acType,
            tradeOf: filters.tradeOf
        },
        enabled: !!filters.acType // Only fetch when acType has a value
    });

    const { mutate: fetchReportData, isPending: isLoading, isError, data: reportData = [], error } = usePost({
        queryKey: ['MemoReport', filters],
        url: apiRoute.salesData.getMemoData,
    });



    // Apply column filters to the data
    const filteredData = useMemo(() => {
        if (!reportData.length) return [];
        return reportData.filter(row => {
            return Object.entries(columnFilters).every(([key, value]) => {
                if (!value) return true;
                const rowValue = row[key] || '';
                return String(rowValue).toLowerCase().includes(String(value).toLowerCase());
            });
        });
    }, [reportData, columnFilters]);

    console.log(reportData)


    const filteredAndGroupedData = useMemo(() => {
        if (!reportData?.length) return [];

        // ---------- FILTER ----------
        // const filteredData = reportData.filter(row =>
        //   Object.entries(columnFilters).every(([key, value]) => {
        //     if (!value) return true;
        //     return String(row[key] ?? '')
        //       .toLowerCase()
        //       .includes(String(value).toLowerCase());
        //   })
        // );

        if (groupBy === 'none') return filteredData;

        // ---------- GROUP ----------
        const groupedData = {};

        const getGroupKey = (row) => {
            switch (groupBy) {
                case 'broker':
                    return row.BrokerDesc || 'Unknown Broker';

                case 'date':
                    return format(new Date(row.Chal_Date), 'yyyy-MM-dd');

                case 'month':
                    return row.YearMonth || 'Unknown Month';

                case 'party':
                    return row.PartyName || 'Unknown Party';

                case 'slcode': // MFG / LOT
                    return isUseMfgNoAsMktno
                        ? (row.L_Code || 'Unknown Lot')
                        : (row.SL_Code || 'Unknown Lot');

                default:
                    return 'all';
            }
        };

        const initGroup = (row, key) => ({
            groupKey: key,

            Chal_Date:
                groupBy === 'date'
                    ? format(new Date(row.Chal_Date), 'dd-MMM-yyyy')
                    : key,

            YearMonth:
                groupBy === 'month'
                    ? row.YearMonth
                    : key,

            PartyName:
                groupBy === 'party'
                    ? row.PartyName
                    : 'Multiple Parties',

            BrokerDesc:
                groupBy === 'broker'
                    ? row.BrokerDesc
                    : 'Multiple Brokers',

            SL_Code: row.SL_Code || 'N/A',
            L_Code: row.L_Code || 'N/A',
            PktNo: 0,
            Weight: 0,
            Pcs: 0,
            Rate: 0,
            S_Rate: 0,
            Amount: 0,
            AmountD: 0,
            // NetAmtRs: 0,
            // NetAmtD: 0,
            _rateWeightedSum: 0,
            _sRateWeightedSum: 0,

            // bill tracker (only for non-lot grouping)
            _billSet: new Set(),

            _children: []
        });

        filteredData.forEach(row => {
            const key = getGroupKey(row);

            if (!groupedData[key]) {
                groupedData[key] = initGroup(row, key);
            }

            const group = groupedData[key];

            const add = (field) => {
                group[field] += Number(row[field]) || 0;
            };

            add('PktNo');
            add('Weight');
            add('Pcs');
            add('Amount');
            add('AmountD');
            // add('NetAmtRs');
            // add('NetAmtD');
            group._rateWeightedSum +=
                (Number(row.Rate) || 0) * (Number(row.Weight) || 0);

            group._sRateWeightedSum +=
                (Number(row.S_Rate) || 0) * (Number(row.Weight) || 0);


            group._children.push(row);
        });

        // ---------- FINALIZE ----------
        return Object.values(groupedData)
            .map(({ _discCount, _rateWeightedSum, _sRateWeightedSum, _billSet, ...rest }) => ({
                ...rest,
                Rate: rest.Weight ? _rateWeightedSum / rest.Weight : 0,
                S_Rate: rest.Weight ? _sRateWeightedSum / rest.Weight : 0
            }))
            .sort((a, b) => {
                if (groupBy === 'date' || groupBy === 'month') {
                    return new Date(a.Chal_Date) - new Date(b.Chal_Date);
                }
                return String(a.groupKey).localeCompare(String(b.groupKey));
            });

    }, [filteredData, columnFilters, groupBy, isUseMfgNoAsMktno]);



    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({ ...prev, [name]: value }));
    };



    // const handleTabChange = (event, newValue) => {
    //   setTabValue(newValue);
    //   setFilters(prev => ({ ...prev, isSummary: newValue === 1 }));
    // };ry


    const handleSubmit = (e) => {
        e.preventDefault();
        if ((filters.fromDate && filters.fromDate == 'Invalid Date')
            || (filters.toDate && filters.toDate == 'Invalid Date')) {
            toast.error("Invalid From Date / To Date", {
                "position": "top-center"
            })
        }
        else {
            const params = {
                ...filters,
                fromDate: filters.fromDate && filters.fromDate != null && filters.fromDate != 'Invalid Date'
                    ? filters.fromDate
                    : '',
                toDate: filters.toDate && filters.toDate != null && filters.toDate != 'Invalid Date'
                    ? filters.toDate //format(filters.toDate, 'yyyy-MM-dd')
                    : ''
            };
            fetchReportData({ data: params });
        }

        // refetch();
    };

    const handleReset = () => {
        setFilters({
            compCode: compCode.join(","),
            dy: '1',
            acYear: '1',
            billType: 'S',
            acType: '13',
            Ac_id: '',
            tradeOf: '',
            Trade_Type: 'ALL',
            Memo_Status: 'ALL',
            Pkt_Type: 'ALL',
            fromDate: dayjs(new Date()).format("YYYY-MM-DD"),//startDate,// new Date(new Date().setDate(new Date().getDate() - 30)),
            toDate: dayjs(new Date()).format("YYYY-MM-DD")//endDate//new Date()
        });
        const params = {
            compCode: compCode.join(","),
            dy: '1',
            acYear: '1',
            billType: 'S',
            acType: '13',
            Ac_id: '',
            tradeOf: '',
            Trade_Type: 'ALL',
            Memo_Status: 'ALL',
            Pkt_Type: 'ALL',
            fromDate: dayjs(new Date()).format("YYYY-MM-DD"),// startDate.split('T')[0],
            toDate: dayjs(new Date()).format("YYYY-MM-DD"),//endDate.split('T')[0]//new Date()
        };
        fetchReportData({ data: params });
    };




    const getReportTitle = () => {
        switch (filters.billType) {
            case 'S': return 'Sales Memo';
            case 'P': return 'Purchase Memo';
            default: return 'Report';
        }
    };

    const getTradeTypeLabel = () => {
        switch (filters.tradeOf) {
            case 'R': return 'Rough';
            case 'P': return 'Polish';
            case 'J': return 'Rejection';
            default: return 'All Types';
        }
    };

    const safeDate = (val) => {
        const d = dayjs(val);
        return d.isValid() ? d : null;
    };
    const gridStyle = {
        flexBasis: {
            xs: '100%',
            sm: '50%',
            md: '25%',
            lg: '20%'
        },
        maxWidth: {
            xs: '100%',
            sm: '50%',
            md: '25%',
            lg: '20%'
        }
    }

    const headCssStyle = { fontSize: "0.7rem", lineHeight: 1.3, textTransform: "uppercase", backgroundColor: '#f0f0f0', fontWeight: 600, color: '#3c3c3c' }
    const columns = useMemo(() => getColumns(groupBy, activeTab, isUseMfgNoAsMktno), [isUseMfgNoAsMktno, groupBy]);
    if (isError) {
        return <ErrorCard />
    }
    if (isLoading) {
        return <LoadingCard />
    }
    return (
        <MainContainer
            pageName={`${filters?.billType == 'P' ? 'Purchase ' : "Sale "} Memo List`}
            breadcrumbs={["Reports", `${filters?.billType == 'P' ? 'Purchase ' : "Sale "} Memo List`]}

        >
            <Box sx={{
                p: isMobile ? 1 : 1,
                backgroundColor: 'background.default',
                minHeight: '100vh',

            }}>
                {/* Header Section */}
                <Box sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    justifyContent: 'space-between',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    gap: 2,
                    mb: 1,
                    p: 1,
                    background: "#ffd3b46a",
                    border: "1px solid #fed3cddc",
                    // backgroundColor: 'background.paper',
                    borderRadius: 1,

                    //boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)'
                }}>
                    <Typography variant="h4" sx={{
                        fontSize: isMobile ? '1rem' : '1rem',
                        fontWeight: 600,
                        color: "#d43d0b",

                        letterSpacing: -0.5

                    }}>
                        {getReportTitle()}
                    </Typography>

                    {reportData.length > 0 && (
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1,
                            alignSelf: { xs: 'stretch', md: 'center' }
                        }}>
                            {/* <Button
                variant="contained"
                color="success"
                startIcon={<FontAwesomeIcon icon={faDownload} />}
                onClick={exportToExcel}
                disabled={filteredData.length === 0}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 3,
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)' }
                }}
              >
                Export Excel
              </Button>

              <Button
                variant="contained"
                color="error"
                startIcon={<FontAwesomeIcon icon={faDownLong} />}
                onClick={exportToPDF}
                disabled={filteredData.length === 0}
                sx={{
                  textTransform: 'none',
                  fontWeight: 500,
                  px: 3,
                  borderRadius: 2,
                  fontSize: "0.8rem",
                  boxShadow: 'none',
                  '&:hover': { boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.2)' }
                }}
              >
                Export PDF
              </Button> */}
                        </Box>
                    )}
                </Box>

                {/* Filters Section */}
                <Paper sx={{
                    py: isMobile ? 1 : 2,
                    px: 1,
                    mb: 1,
                    borderRadius: 3,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
                    backgroundColor: 'background.paper'
                }}>
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ mb: 0 }}>

                            {/* Hidden Fields */}
                            <Grid item xs={12} sx={{ display: 'none' }}>
                                <TextField name="compCode" value={filters.compCode} />
                                <TextField name="dy" value={filters.dy} />
                                <TextField name="acYear" value={filters.acYear} />
                            </Grid>

                            {/* Shared responsive style */}
                            {/*
      xs = 100%
      sm = 50% (2 per row)
      md = 25% (4 per row iPad)
      lg = 20% (5 per row desktop)
    */}


                            {/* Bill Type */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 600 }}>Bill Type</InputLabel>
                                    <Select
                                        name="billType"
                                        value={filters.billType}
                                        label="Bill Type"
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            let acType = '';
                                            if (val === 'S') acType = '13';
                                            else if (val === 'P') acType = '11';

                                            setFilters(prev => ({ ...prev, billType: val, acType }));
                                        }}
                                        sx={{ height: 35, background: "#c2d8f84d", }}
                                    >
                                        <MenuItem value="S">Sales</MenuItem>
                                        <MenuItem value="P">Purchase</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Trade Of */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 500 }}>Trade Of</InputLabel>
                                    <Select
                                        name="tradeOf"
                                        value={filters.tradeOf}
                                        onChange={handleFilterChange}
                                        label="Trade Of"
                                        //  variant='outlined'
                                        // color="primary"
                                        sx={{ height: 35, }}
                                    >
                                        <MenuItem value="">None</MenuItem>
                                        <MenuItem value="R">Rough</MenuItem>
                                        <MenuItem value="P">Polish</MenuItem>
                                        <MenuItem value="J">Rejection</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Account */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 500 }}>Account</InputLabel>
                                    <Select
                                        value={filters.Ac_id || ''}
                                        onChange={(e) =>
                                            setFilters(prev => ({ ...prev, Ac_id: e.target.value }))
                                        }
                                        sx={{ height: 35 }}
                                    >
                                        <MenuItem value=""><em>None</em></MenuItem>
                                        {partyData.map(p => (
                                            <MenuItem key={p.AC_ID} value={p.AC_ID}>
                                                {p.AC_DESC}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Trade Type */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 600 }}>Memo Status</InputLabel>
                                    <Select
                                        name="Memo_Status"
                                        value={filters.Memo_Status || 'ALL'}
                                        onChange={handleFilterChange}
                                        label="Memo Status"
                                        sx={{ height: 35 }}
                                    >
                                        <MenuItem value="ALL">All</MenuItem>
                                        <MenuItem value={ENUM_STATUS.Pending}>{ENUM_STATUS.Pending}</MenuItem>
                                        <MenuItem value={ENUM_STATUS.Final}>{ENUM_STATUS.Final}</MenuItem>
                                        <MenuItem value={ENUM_STATUS.Return}>{ENUM_STATUS.Return}</MenuItem>
                                        <MenuItem value={ENUM_STATUS.PartialFinal}>{ENUM_STATUS.PartialFinal}</MenuItem>
                                        <MenuItem value={ENUM_STATUS.PartialReturn}>{ENUM_STATUS.PartialReturn}</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* Packet Type */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 600 }}>Packet Type</InputLabel>
                                    <Select
                                        name="Pkt_Type"
                                        value={filters.Pkt_Type || "ALL"}
                                        onChange={handleFilterChange}
                                        label="Packet Type"
                                        sx={{ height: 35, background: "#c2d8f84d", }}
                                    >
                                        <MenuItem value="ALL">All</MenuItem>
                                        <MenuItem value="SNG">Single</MenuItem>
                                        <MenuItem value="MIX">Mix</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* From Date */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <Box sx={{ width: '100%' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="From Date"
                                            format="DD/MM/YYYY"
                                            value={filters.fromDate ? dayjs(filters.fromDate) : null}
                                            onChange={(val) =>
                                                setFilters(prev => ({
                                                    ...prev,
                                                    fromDate: val ? dayjs(val).format("YYYY-MM-DD") : null
                                                }))
                                            }
                                            views={["day", "month", "year"]}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    InputLabelProps: { sx: { fontWeight: 600 } }
                                                },
                                                popper: {
                                                    placement: "bottom-start",
                                                    disablePortal: false,
                                                    sx: { zIndex: 99999 }
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            {/* To Date */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <Box sx={{ width: '100%' }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            label="To Date"
                                            format="DD/MM/YYYY"
                                            value={filters.toDate ? dayjs(filters.toDate) : null}
                                            onChange={(val) =>
                                                setFilters(prev => ({
                                                    ...prev,
                                                    toDate: val ? dayjs(val).format("YYYY-MM-DD") : null
                                                }))
                                            }
                                            views={["day", "month", "year"]}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    InputLabelProps: { sx: { fontWeight: 600 } }
                                                },
                                                popper: {
                                                    placement: "bottom-start",
                                                    disablePortal: false,
                                                    sx: { zIndex: 99999 }
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </Grid>

                            {/* Order By */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <FormControl fullWidth size="small">
                                    <InputLabel sx={{ fontWeight: 600 }}>Order By</InputLabel>
                                    <Select
                                        value={groupBy}
                                        onChange={(e) => setGroupBy(e.target.value)}
                                        sx={{ height: 35 }}
                                    >
                                        <MenuItem value="none">Report Detail</MenuItem>
                                        <MenuItem value="broker">Broker</MenuItem>
                                        <MenuItem value="date">Date</MenuItem>
                                        <MenuItem value="month">Month</MenuItem>
                                        <MenuItem value="party">Party</MenuItem>
                                        {/* <MenuItem value="slcode">
                                            "LOT NO" 
                                        </MenuItem> */}
                                    </Select>
                                </FormControl>
                            </Grid>

                            {/* BUTTONS */}
                            <Grid item xs={12} sm={6} md={2.4} sx={gridStyle}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        gap: 1,
                                        alignItems: 'center',
                                        justifyContent: 'flex-center',
                                        height: '100%'
                                    }}
                                >


                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="warning"
                                        disabled={isLoading}
                                        sx={{
                                            minWidth: 90,
                                            height: 35,
                                            textTransform: 'none',
                                            fontWeight: 600,

                                        }}
                                        startIcon={<FontAwesomeIcon style={{ fontSize: "0.9rem" }} icon={faSearch} className='text-md' ></FontAwesomeIcon>}
                                    >
                                        {isLoading ? 'Searching' : 'Search'}
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="primary"
                                        onClick={handleReset}
                                        sx={{
                                            minWidth: 90,
                                            height: 35,
                                            textTransform: 'none',
                                            fontWeight: 600
                                        }}
                                        startIcon={<FontAwesomeIcon style={{ fontSize: "0.9rem" }} icon={faRefresh} className='text-md' ></FontAwesomeIcon>}
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>

                        </Grid>
                    </form>
                </Paper>

                {/* Error Message */}
                {isError && (
                    <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
                        <AlertTitle>Error</AlertTitle>
                        {error.message}
                    </Alert>
                )}

                {/* Data Table Section */}
                <Paper sx={{
                    p: isMobile ? 1 : 0,
                    borderRadius: 3,
                    boxShadow: '0px 2px 10px rgba(0, 0, 0, 0.08)',
                    backgroundColor: 'background.paper'
                }} ref={tableRef}>
                    {/* Table Header */}


                    {/* Data Table */}
                    {reportData.length > 0 ? (
                        <Box sx={{ width: "100%", overflowX: "auto" }}>
                            <MUIDataTable
                                data={filteredAndGroupedData}
                                dataColumns={columns}
                                reportTitle={filters?.billType == 'P' ? "Purchase Memo Report" : filters?.billType == 'S' ? "Sale Memo Report" : filters?.billType == "N" ? "Sale Return Report" : filters?.billType == "T" ? "Purchase Return Report" : "report"}
                                orderGroup={groupBy}
                                enableCurrency={true}
                                filterDate={filters}
                                tradeLabel={`Trade: ${getTradeTypeLabel()}`}
                                companyName={compName.join(",")}
                                hideIfZeroKeys={[]}
                                exportColumnKeys={exportColumnKeys}
                                enableHeaderFilter={true}
                                minColWidth="90"
                               // headClass={{'main':'bg-red-700','sub':'bg-red-50'}}
                               // pagingColor="#b60f0f"

                            />
                        </Box>
                    ) : (
                        !isLoading && (
                            <Box sx={{
                                p: 4,
                                textAlign: 'center',
                                border: `1px dashed ${theme.palette.divider}`,
                                borderRadius: 2,
                                backgroundColor: 'background.default'
                            }}>
                                <Box sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 2
                                }}>
                                    <FontAwesomeIcon icon={faInfo} />
                                    {/* <DescriptionOutlined sx={{
                  fontSize: 48,
                  color: 'text.disabled'
                }} /> */}
                                    <Typography variant="h6" color="text.secondary">
                                        No  data available
                                    </Typography>
                                    <Typography variant="body1" color="text.secondary">
                                        Apply filters above to generate a report
                                    </Typography>
                                </Box>
                            </Box>
                        )
                    )}
                </Paper>


            </Box>
        </MainContainer>
    );
};

export default MemoReport;
